import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CustomItem, NestingItem, Section } from '@atlaskit/side-navigation';
import { getPartnerNavLinks } from '@atlassian/mpac-utils';
import React from 'react';
import { Link as RouteLink } from 'react-router-dom';
import { nestedNav, SideNavIconsMapping, SideNavNames } from './PartnerSideNav.constants';
import { getAuthorisedNavList, getFirstNavItem } from './PartnerSideNav.utils';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const PartnerSideNavItem = _ref => {
  let {
    navItem,
    selectedNavItems,
    authroisedNavItems,
    id
  } = _ref;
  const Icon = SideNavIconsMapping[navItem];
  const links = getPartnerNavLinks();
  if (nestedNav[navItem]) {
    return /*#__PURE__*/_jsx(NestingItem, {
      id: navItem,
      isSelected: selectedNavItems.includes(navItem),
      title: SideNavNames[navItem],
      testId: "nested-".concat(navItem),
      component: props => /*#__PURE__*/_jsx(RouteLink, _objectSpread(_objectSpread({}, props), {}, {
        to: links[getFirstNavItem(nestedNav[navItem], authroisedNavItems)].expand({
          id
        }),
        children: props.children
      })),
      iconBefore: /*#__PURE__*/_jsx(Icon, {
        label: SideNavNames[navItem]
      }),
      children: /*#__PURE__*/_jsx(PartnerSideNavContent, {
        navList: nestedNav[navItem],
        authroisedNavItems: authroisedNavItems,
        selectedNavItems: selectedNavItems,
        id: id
      })
    });
  }
  return /*#__PURE__*/_jsx(CustomItem, {
    isSelected: selectedNavItems.includes(navItem),
    iconBefore: Icon && /*#__PURE__*/_jsx(Icon, {
      label: SideNavNames[navItem]
    }),
    component: RouteLink,
    to: links[navItem].expand({
      id
    }),
    testId: "custom-".concat(navItem),
    children: SideNavNames[navItem]
  });
};
const PartnerSideNavContent = props => {
  const authorisedNavList = getAuthorisedNavList(props.navList, props.authroisedNavItems);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: authorisedNavList.map(list => /*#__PURE__*/_jsx(Section, {
      isList: true,
      title: list.title,
      testId: "side-nav-list",
      children: list.navItems.map(navItem => /*#__PURE__*/_jsx(PartnerSideNavItem, {
        navItem: navItem,
        selectedNavItems: props.selectedNavItems,
        authroisedNavItems: props.authroisedNavItems,
        id: props.id
      }, SideNavNames[navItem]))
    }, list.title))
  });
};
export default PartnerSideNavContent;